import { DatePicker, useDateForQueryParams } from "components/DatePicker";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

type TProps = {
  initFromDate?: string;
  initToDate?: string;
  onChange: (date: [string | undefined, string | undefined]) => void;
  disabled?: boolean;
  className?: string;
};
export default function DateRangePicker(props: TProps) {
  const { initFromDate, initToDate, onChange, disabled, className } = props;
  const { t } = useTranslation();
  const [convertDateForQueryParam] = useDateForQueryParams();

  // const onDateChange = (value: any, type: "FROM" | "TO") => {
  //   if (type === "FROM") {
  //     onChange([value, undefined]);
  //   } else {
  //     onChange([undefined, value]);
  //   }
  // }
  return (
    <div className={clsx("w-full flex gap-x-3 min-w-[412px]", className)}>
      <DatePicker
        callback={(res) => {
          onChange([convertDateForQueryParam(res), undefined]);
        }}
        defaultValueDate={initFromDate}
        showDefaultDate={false}
        className="w-1/2 max-w-[200px]"
        disabled={disabled}
        label={t("fromDate")}
      />
      <DatePicker
        callback={(res) => {
          onChange([undefined, convertDateForQueryParam(res)]);
        }}
        defaultValueDate={initToDate}
        showDefaultDate={false}
        className="w-1/2 max-w-[200px]"
        disabled={disabled}
        label={t("toDate")}
      />
    </div>
  );
}
